import { useContext } from "react";
import { MediasoupClientContext } from "../contexts/MediasoupClientContext";

export const useMediasoupClient = () => useContext(MediasoupClientContext);
